// api封装
import { post, get } from './http';
//import fa from "element-ui/src/locale/lang/fa";
// import { Constants } from '../utils/constants';

// const {
//   MERCHANT, ORDER, GOODS, GOODS_CATEGORY, FREIGHT_PLAN, DELIVERY_TIME_TYPE,
// } = Constants;

export default {
  // 前台
  index: {
    zh: params => post('site/index',params,true),//链接转换
    jubao: params => get('site/jubao',params,true),//链接转换
    addHuoMa: params => get('userExcDomain/addHuoMa',params,true),//生成活码

    huoMaList: params => get('userExcDomain/huoMaList',params,true),//活码详情

    getLinkInfo: params => get('site/getLinkInfo',params,true),//链接转换结果
    getRecordingList: params => get('site/getRecordingList',params,true),//获取游客链接转换记录
  },
  //短网址
  shortUrl: {
    zh: params => post('shortUrl/index',params,true),//链接转换
    renling: params => post('shortUrl/renling',params,true),//链接认领
    weibo: params => post('shortUrl/weibo',params,true),//微博链接转换
    batch: params => post('shortUrl/batchConversion',params,true),//链接批量转换
    list: params => get('shortUrl/getUrlList',params,false),//获取链接列表
    delLink: params => get('shortUrl/delLink',params,true),//删除链接
    delMlink: params => get('shortUrl/delMlink',params,true),//删除随机链接
    saveMark: params => get('shortUrl/saveMark',params,true),//更新备注
    saveLimit: params => get('shortUrl/saveLimit',params,true),//更新限制
    replaceUrl: params => post('shortUrl/replaceUrl',params,false),//链接替换
    replaceUrlFix: params => post('shortUrl/replaceFix',params,false),//短链接替换
    replaceWord: params => post('shortUrl/replaceWord',params,false),//字符替换
    loadingWord: params => post('shortUrl/loadingWord',params,false),//字符替换
    getLinkInfo: params => get('shortUrl/getLinkInfo',params,true),//获取链接信息
    editLink: params => post('shortUrl/editLink',params,true),//编辑链接
    seniorLink: params => get('shortUrl/seniorLink',params,true),//高级功能
    delSeniorLink: params => get('shortUrl/delSeniorLink',params,true),//删除高级功能链接
    saveArea: params => post('shortUrl/updateArea',params,false),//保存高级功能地区定位
    saveDevice: params => post('shortUrl/updateDev',params,false),//保存高级功能设备定位
    saveMlink: params => post('shortUrl/updateMlink',params,false),//保存高级功能随机多链接
    delArea: params => get('shortUrl/delArea',params,true),//删除高级功能地区定位
    delDevice: params => get('shortUrl/delDev',params,true),//删除高级功能设备定位
    getInitialData: params => get('shortUrl/statistics',params,true),//数据统计
    getStatInitialData: params => get('shortUrl/statisticsAll',params,true),//数据统计
    getAccessRecord: params => get('shortUrl/getAccessRecords',params,false),//数据统计
    getAllAccessRecord: params => get('shortUrl/getAccessRecordsAll',params,false),//数据统计
  },
  vip: {
    addOrder: params => post('vip/addOrder',params,false),//vip开通
    queryOrder: params => get('vip/queryOrder',params,false),//vip开通支付状态查询
  },
  imgbig:{
    create: params => post('product/create',params,true),//
    getList: params => get('product/historyList',params,false),//
    del: params => post('product/historyDelete',params,true),//

  },
  webpage:{
    create: params => post('webPage/create',params,true),//生成单网页
    getList: params => get('webPage/getList',params,false),//获取列表
    getOne: params => get('webPage/getOne',params,false),//h5详情
    update: params => post('webPage/update', params,false), //修改
    addOrder: params => post('webPage/addOrder',params,false),//购买单页包
    queryOrder: params => get('webPage/queryOrder',params,false),//专属域名支付状态查询
    getPackList: params => get('webPage/getPackList',params,false),//获取访问包列表

  },

  //专属域名
  exclusive: {
    getList: params => get('excDomain/getDomainList',params,false),//获取专属域名列表

    addOrder: params => post('excDomain/addOrder',params,false),//购买专属域名
    renew: params => post('excDomain/renew',params,false),//专属域名续费
    queryOrder: params => get('excDomain/queryOrder',params,false),//专属域名支付状态查询
    getOrderList: params => get('excDomain/getOrderList',params,false),//获取用户专属域名订单列表
    celOrder: params => get('excDomain/celOrder',params,true),//取消用户专属域名订单
    delOrder: params => get('excDomain/delOrder',params,true),//删除用户专属域名订单
    zh: params => post('userExcDomain/index',params,true),//链接转换
    addGoodsLink: params => post('userExcDomain/addGoodsLink',params,true),//生成微信淘宝链接
    getTbInfo: params => post('userExcDomain/getTbInfo',params,true),//获取淘宝商品信息
    getUserList: params => get('userExcDomain/getDomainList',params,false),//获取用户专属域名列表
    getUserDomainList: params => get('userExcDomain/getDomainLists',params,false),//获取用户专属域名列表
    getUserDomainListStat: params => get('userExcDomain/getDomainListStat',params,false),//获取用户专属域名列表统计
    delUserDomain: params => get('userExcDomain/del',params,false),//批量删除专属域名
    saveDomainMark: params => post('userExcDomain/updateMark',params,false),//修改用户专属域名备注
    saveDomainIndexUrl: params => post('userExcDomain/setIndexUrl',params,false),//修改用户专属域名地址
    saveDiyDomain: params => post('userExcDomain/updateDiyDomain',params,false),//新增自定义专属域名
    saveDiyDomainMore: params => post('userExcDomain/updateDiyDomainMore',params,false),//批量新增自定义专属域名
    replaceWord: params => post('userExcDomain/replaceWord',params,false),//字符替换
    getLongurlList: params => get('userLongurl/getList',params,false),//专属中间域名
    saveLongurlMark: params => get('userLongurl/saveMark',params,true),//更新备注
    delLongurl: params => get('userLongurl/del',params,true),//删除链接分类
  },
  //访问包
  flowPack: {
    getList: params => get('flowPack/list',params,false),//获取访问包列表
    getFlowList: params => get('flowPack/getUserFlowList',params,false),//获取链接分类列表
    addOrder: params => post('flowPack/addOrder',params,false),//购买访问包
    queryOrder: params => get('flowPack/queryOrder',params,false),//专属域名支付状态查询

  },
  //源代码购买接口
  source: {
    addOrder: params => post('sourceOrder/addOrder',params,false),//购买
    queryOrder: params => get('sourceOrder/queryOrder',params,false),//支付状态查询
    download: params => get('sourceOrder/download',params,false),//支付状态查询

  },
  ckdomain: {
    search: params => post('ckDomain/search',params,false),//vip开通
    queryOrder: params => get('ckDomain/queryOrder',params,false),//vip开通支付状态查询
  },
  //分类
  urlLabel: {
    getClassList: params => get('urlLabel/getUrlLabelList',params,false),//获取链接分类列表
    getLabelList: params => get('urlLabel/getLabelList',params,false),//获取链接分类列表
    setUrlClass: params => get('urlLabel/setUrlLabel',params,true),//设置链接分类
    setUrlLinkClass: params => get('urlLabel/setUrlLink',params,true),//设置链接
    updateLabel: params => post('urlLabel/update',params,false),//添加链接分类
    delLabel: params => get('urlLabel/del',params,true),//删除链接分类
  },
  //小程序
  xcx: {
    getList: params => get('xcx/getXcxList',params,false),//获取小程序列表
    update: params => post('xcx/update',params,false),//编辑小程序
    del: params => get('xcx/del',params,true),//删除链接分类
  },
  xcxLink: {
    getList: params => get('xcxLink/getList',params,false),//获取小程序列表
    update: params => post('xcxLink/update',params,false),//编辑小程序
    del: params => get('xcxLink/del',params,true),//删除链接分类
  },
  //网站监控
  monitorUrl: {
    getList: params => get('userCkUrl/getList',params,false),//获取链接分类列表
    updateUserCkUrl: params => post('userCkUrl/update',params,false),//添加链接分类
    update2UserCkUrl: params => post('userCkUrl/update2',params,false),//批量添加
    del: params => get('userCkUrl/del',params,true),//删除链接分类
    import: params => get('userCkUrl/import',params,true),//导入长链接
  },
  //数据导出
  export: {
    getList: params => get('export/getList',params,false),//获取导出列表
    addExport: params => get('export/add',params,false),//新建导出任务
    delExport: params => get('export/del',params,true),//删除导出任务
  },
  // 消息通知
  notice: {
    pmRead: params => get('notice/pmRead', params,true), // 消息已读
    readAll: params => get('notice/readAll', params,true), // 全部标记为已读
    overview: params => get('notice/overview', params,false), // 获取消息概况（最多5条）
    query: params => get('notice/query', params,true), // 获取消息分页列表
    getList: params => get('notice/getList', params,true), // 获取消息列表
  },
  //用户中心
  user: {
    getUserInfo: params => get('user/getUserInfo', params,false), // 获取用户信息
    saveNickname: params => post('user/editNickname', params,true), // 获取用户信息
    saveEmail: params => post('user/saveEmail', params,true), // 获取用户信息
	saveQrlogo: params => post('user/saveQrlogo', params,true), // 获取用户信息
	saveQrlogoList: params => post('user/saveQrlogoList', params,true), // 获取用户信息
    savePass: params => post('user/savePass', params,true), // 获取用户信息
    getUserToken: params => get('user/getUserToken', params,true), // 获取用户信息
    resetToken: params => get('user/resetToken', params,true), // 重置用户Token
    certification: params => get('user/certification', params,true), // 认证
    getCertification: params => get('user/getCertification', params,false,false), // 获取认证信息
    addChargeOrder: params => post('user/addChargeOrder',params,false),//vip开通
    queryChargeOrder: params => get('user/queryOChargeOrder',params,false),//vip开通支付状态查询
    refreshChargeUsdt: params => get('user/refreshChargeUsdt',params,false),//vip开通支付状态查询
    payCharge:params => get('user/payCharge',params,false),//vip开通支付状态查询

  },
  //渠道
  channel: {
    getList: params => get('urlChannel/getList', params,false), //获取渠道列表
    getLinkInfo: params => get('urlChannel/getChannelInfo', params,false), //获取渠道链接信息
    batchCreation: params => get('urlChannel/batchCreation', params,false), //批量创建渠道
  },
  //活码
  livecode: {
    amendNmae: params => get('userExcDomain/amendNmae', params,false), //修改活码名称
    addimg: params => get('userExcDomain/addHuoMaImg', params,false), //添加图片
    amendimg: params => get('userExcDomain/amendHuoMaImg', params,false), //修改图片
    dleImg: params => get('userExcDomain/DelHuoMaImg', params,false), //删除图片
    batchVisit: params => get('userExcDomain/BatchVisit', params,false), //批量修改浏览量
    liveCodeSet: params => get('userExcDomain/LiveCodeSet', params,false), //批量修改浏览量
    liveCodelist: params => get('userExcDomain/getLiveCodeList',params,false),//获取链接列表

    webPageSet: params => get('userExcDomain/WebPageSet', params,false), //批量修改浏览量
  },
  //活码
  paycode: {
    addHuoMa: params => get('payCode/addHuoMa',params,true),//生成活码
    amendNmae: params => get('payCode/amendNmae', params,false), //修改名称
    addimg: params => get('payCode/addHuoMaImg', params,false), //添加图片
    amendimg: params => get('payCode/amendHuoMaImg', params,false), //修改图片
    dleImg: params => get('payCode/DelHuoMaImg', params,false), //删除图片
    batchVisit: params => get('payCode/BatchVisit', params,false), //批量修改浏览量
    liveCodeSet: params => get('payCode/LiveCodeSet', params,false), //批量修改浏览量
    liveCodelist: params => get('payCode/getLiveCodeList',params,false),//获取链接列表
    webPageSet: params => get('payCode/WebPageSet', params,false), //批量修改浏览量
    huoMaList: params => get('payCode/huoMaList',params,true),//活码详情
  },


  // 公共
  login: params => post('passport/login', params,false), // 验证码登录
  reg: params => post('passport/reg', params,false), // 注册
  passLogin: params => post('passport/passLogin', params,false), // 密码登录
  wxLogin: params => get('passport/wxMpLogin', params,false), // 微信登录
  wxQrCode: params => get('passport/wxMpLoginQrcode', params,true), // 微信登录二维码
  logout: params => get('passport/logout', params,true), // 注销
  getCode: params => get('verifyCode/getCode', params,true), // 获取图形验证码
  captcha: params => get('verifyCode/captcha', params,true), //验证图形验证码
  sendSms: params => get('verifyCode/sendSms2', params,true), //发送验证码
  getIdentity: params => get('passport/getIdentity',params,false), //获取游客身份标识
  authorization: params => get('passport/authorization',params,false),//验证登入状态
  getWxInfo: params => get('passport/getWxInfo',params,true),//获取微信资料
  wxBindPhone: params => post('passport/wxBindPhone',params,true),//微信账户绑定手机号
  telegramAuth: params => get('passport/telegramLogin', params,true), // 微信登录二维码
};
